import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  TextareaAutosize,
  makeStyles,
  withStyles
} from '@material-ui/core';
import { connect } from 'react-redux';
import { getUser } from '../../../redux/reducers/user/selectors';
import UserApi from '../../../utils/apiManager/constrollers/userApi';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '20px 0 0 0',
    float: 'left'
  },
  cardContent: {
    float: 'left',
  },
  planCards: {
    width: 240,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  customText: {
    height: 50
  }
}));

const ContactView = ({ className, user, ...rest }) => {
  const classes = useStyles();
  const [values, setValues] = useState(user);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSending(true);
    try {
      const api = await UserApi.getInstance();
      await api.sendContactMessage({
        name: `${values.firstname || ''} ${values.surname || ''}`.trim(),
        email: values.email,
        phone: values.phone || '101',
        message,
      });
      setSent(true);
      setMessage('');
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      onSubmit={handleSend}
      {...rest}
    >
      <Card>
        <CardHeader
          title="Contact"
        />
        <Divider />
        <CardContent className={classes.cardContent}>
          <Grid
            container
            spacing={2}
            className={classes.cardContent}
          >
            <Grid
              item
              md={3}
              xl={12}
            >
              <TextField
                fullWidth
                label={<FormattedMessage id="label.first.name" defaultMessage="First name"/>}
                name="firstName"
                required
                value={values.firstname}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label={<FormattedMessage id="label.last.name" defaultMessage="Last name"/>}
                name="lastName"
                required
                value={values.surname}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email"
                name="email"
                required
                value={values.email}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                id='messageField'
                fullWidth
                required
                InputProps={{ style: {minHeight: 200, padding: '0 14px'}}}
                label={<FormattedMessage id="label.message" defaultMessage="Message"/>}
                name="message"
                variant="outlined"
                placeholder="Empty"
                multiline
                rows={1}
                rowsMax={Infinity}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <Box
                display="flex"
                justifyContent="flex-end"
                p="2"
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={sending || sent || !message.trim()}
                >
                  <FormattedMessage
                    id={sent ? 'label.sent' : 'label.first.send'}
                    defaultMessage={sent ? 'Sent' : 'Send'}
                  />
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  );
};

ContactView.propTypes = {
  className: PropTypes.string
};

export default connect(getUser, {})(ContactView);
